module.exports = __webpack_public_path__ + "static/media/background1.65012072.jpeg";